import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface MoreInfoIconProps {
  text: string;
}

const MoreInfoIcon: React.FC<MoreInfoIconProps> = ({ text }) => {
  return (
    <OverlayTrigger
      delay={{ show: 0, hide: 100 }}
      overlay={
        <Tooltip>
          <span className="text-gray-400 fw-bold d-block fs-7 text-start">
            {text}
          </span>
        </Tooltip>
      }
    >
      <i className="fa-regular fa-circle-info text-muted cursor-pointer"></i>
    </OverlayTrigger>
  );
};
export default MoreInfoIcon;
